<template>
  <div>
    <!-- 列表 begin -->
    <div class="list-unstyled font-size-md mb-0">
      <!-- 會員中心-我的訂單-商品列表 begin-->
      <template v-if="order.hasLoaded">
        <template v-for="item in order.items">
          <div class="d-flex my-4" :key="item.productCode + item.subProductCode">
            <figure class="pr-2">
              <!-- <router-link to="/McfGiftDetialMobile" class="image-panel image-panel-2"><img :src="item.sPicture" :alt="item.productName_CH" class="mw-100"></router-link> -->
              <div class="image-panel image-panel-2"><img :src="item.sPicture" :alt="item.productName_CH" class="mw-100"></div>
            </figure>
            <div class="flex-grow-1">
              <h6 class="font-size-md text-truncate-2">{{ item.productName_CH }}</h6>
              <div class="d-flex justify-content-between align-items-center text-gray600">
                <div class="flex-grow-1">{{ item.spec | compose }}</div>
                <div>X{{ item.qty }}</div>
              </div>
              <slot name="itemAccount">
                <div class="d-flex justify-content-end align-items-center font-size-initial">{{ order.isTEECOrder ? item.subAmount : item.price | currency(order.currency) }}</div>
              </slot>
            </div>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="d-flex my-4">
          <figure class="pr-2">
            <div class="image-panel image-panel-2" v-skeleton-loader><img src="" alt="" class="mw-100"></div>
          </figure>
          <div class="flex-grow-1">
            <h6 class="font-size-md text-truncate-2" v-skeleton-loader></h6>
            <div class="d-flex justify-content-between align-items-center text-gray600">
              <div class="flex-grow-1" v-skeleton-loader></div>
              <div></div>
            </div>
          </div>
        </div>
      </template>
      <!-- 會員中心-我的訂單-商品列表 end-->
    </div>
    <hr>
    <!-- 列表 end -->
    <!-- 小計/總計 begin -->
    <div class="container font-size-md text-gray600">
      <!-- 兌禮總計 begin -->
      <!-- <div class="row justify-content-end align-items-center">
        <div class="col-8 text-right">共 3 件，總計點數</div>
        <div class="col-4 text-right px-0"><span class="text-danger font-weight-bold">5,200</span></div>
      </div> -->
      <!-- 兌禮總計 end -->
      <!-- 我的訂單總計 begin -->
      <div class="row justify-content-end align-items-center">
        <div class="col-8 text-right">{{ $t('order.total-quantity', { quantity: totalQty }) }}</div>
        <div class="col-4 text-right px-0">{{ subTotal | currency(order.currency) }}</div>
      </div>
      <template v-if="!isReturnRequestPage">
        <div class="row justify-content-end align-items-center">
          <div class="col-8 text-right">{{ $t('order.shipping-fee') }}</div>
          <div class="col-4 text-right px-0">{{ order.shippingFee | currency(order.currency) }}</div>
        </div>
        <div class="row justify-content-end align-items-center">
          <div class="col-8 text-right">{{ $t('order.discount') }}</div>
          <div class="col-4 text-right px-0"><span class="text-danger">-{{ discount | currency(order.currency) }}</span></div>
        </div>
        <div class="row justify-content-end align-items-center">
          <div class="col-8 text-right">{{ `Coupon ${$t('order.offset')}` }}</div>
          <div class="col-4 text-right px-0"><span class="text-danger">-{{ order.couponDiscount | currency(order.currency) }}</span></div>
        </div>
        <div class="row justify-content-end align-items-center">
          <div class="col-8 text-right">{{ pointUnit + $t('order.offset') }}</div>
          <div class="col-4 text-right px-0"><span class="text-danger">-{{ order.pointDiscount | currency(order.currency) }}</span></div>
        </div>
        <div class="row justify-content-end align-items-center" v-if="(checkEeventstatus('21') || checkEeventstatus('72')) && order.isReturnRequest">
          <div class="col-8 text-right">{{ $t('order.return.orderreturn') }}</div>
          <div class="col-4 text-right px-0"><span class="text-danger">-{{ order.totalPrice | currency(order.currency) }}</span></div>
        </div>
        <div class="row justify-content-end align-items-center" v-if="(checkEeventstatus('21') || checkEeventstatus('72') || checkEeventstatus('71')) && order.isCancelRequest">
          <div class="col-8 text-right">{{ $t('order.cancel.ordercancel') }}</div>
          <div class="col-4 text-right px-0"><span class="text-danger">-{{ order.totalPrice | currency(order.currency) }}</span></div>
        </div>
        <div class="row justify-content-end align-items-center text-body font-weight-bold">
          <div class="col-8 text-right">{{ $t('order.total-price') }}</div>
          <div class="col-4 text-right px-0">{{ totalPriceProcessing() }}</div>
        </div>
      </template>
      <!-- 我的訂單 end -->
    </div>
    <!-- 小計/總計 end -->
  </div>
</template>

<script>
import pageSettingGetter from '@/utils/pageSettingGetter';
import currency from '@/filters/currency';

export default {
  props: {
    order: {
      type: Object,
    },
    // 退貨頁面不需顯示
    isReturnRequestPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 點數單位
      pointUnit: '',
      // 最新的狀態
      orderOldestEvent: this.order.events[this.order.events.length - 1],
    };
  },
  computed: {
    // 折扣(totalDiscount - pointDiscount - couponDiscount)
    discount() {
      return this.order.discount - this.order.pointDiscount - this.order.couponDiscount;
    },
    // 取得商品總數
    totalQty() {
      return this.order.items.reduce((sum, item) => sum + item.qty, 0);
    },
    // 取得商品小計
    subTotal() {
      return this.order.items.reduce((sum, item) => sum + (this.order.isTEECOrder ? item.subAmount : item.price) * item.qty, 0);
    },
  },
  filters: {
    compose(spec) {
      // 無規格資料或單一規格設為空值
      if (!spec || spec.specTypeDesc1 === '無規格') return '';
      // 有規格名稱就加到陣列中
      const specNames = Object.keys(spec)
        .filter((key) => key.includes('specItemDesc') && spec[key] && spec[key] !== 'F')
        .map((key) => (spec[key]));

      return specNames.join(', ');
    },
  },
  created() {
    const vm = this;
    // 點數單位
    vm.$store.dispatch('getPageSetting', 'MemberCentreHomePage')
      .then((setting) => {
        vm.pointUnit = pageSettingGetter.getFunctionWording(setting, 'UserPointUnit');
      });
  },
  methods: {
    totalPriceProcessing() {
      const vm = this;
      const oldestevent = vm.orderOldestEvent;
      // 針對退貨中，當同意或是完成退貨時，總金額要為0
      if (oldestevent.category === 'Return') {
        if (oldestevent.status.toString() === '21' || oldestevent.status.toString() === '72') {
          const accountafterreturn = parseInt(vm.order.totalPrice, 10) - parseInt(vm.order.totalPrice, 10);
          return currency(accountafterreturn.toString(), vm.order.currency);
        }
      }

      // 針對退貨中，當同意或是完成取消時，總金額要為0
      if (oldestevent.category === 'Cancel') {
        if (oldestevent.status.toString() === '21' || oldestevent.status.toString() === '72' || oldestevent.status.toString() === '71') {
          const accountafterreturn = parseInt(vm.order.totalPrice, 10) - parseInt(vm.order.totalPrice, 10);
          return currency(accountafterreturn.toString(), vm.order.currency);
        }
      }
      return currency(vm.order.totalPrice, vm.order.currency);
    },
    checkEeventstatus(type) {
      if (this.orderOldestEvent.category === 'Return') {
        if (this.orderOldestEvent.status.toString() === type) {
          return true;
        }
      }

      if (this.orderOldestEvent.category === 'Cancel') {
        if (this.orderOldestEvent.status.toString() === type) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
